<label [for]="name()" class="flex w-full flex-col gap-1">
  @if (label()) {
    @if (!labelTemplate()) {
      <span>{{ label() }}</span>
    } @else {
      <ng-container
        [ngTemplateOutlet]="labelTemplate()"
        [ngTemplateOutletContext]="{ $implicit: label() }" />
    }
  }

  <div class="flex flex-col">
    <ng-content></ng-content>
    <div class="flex gap-2" [ngClass]="{ 'flex-col': this.direction() === 'vertical' }">
      @for (checkbox of checkboxes(); track $index) {
        <shared-ui-checkbox-signal [checkbox]="checkbox" [label]="checkbox.text" />
      }
    </div>
  </div>
  @if (!isValid()) {
    @for (error of fieldState().errors(); track error) {
      <span class="text-error">{{ error.message }}</span>
    }
  }
</label>
